import React from 'react';
import { Button, ButtonProps } from '@mui/material';

interface StyledButtonProps extends Omit<ButtonProps, 'variant'> {
  /** アイコンのみ表示（正方形） */
  iconOnly?: boolean;
}

const StyledButton: React.FC<StyledButtonProps> = ({ children, sx, iconOnly = false, ...rest }) => {
  return (
    <Button
      variant="contained"
      sx={{
        backgroundColor: 'rgba(255, 255, 255, 0.06)',
        backdropFilter: 'blur(8px)',
        border: '1px solid rgba(255, 255, 255, 0.12)',
        color: 'text.secondary',
        fontWeight: 400,
        letterSpacing: '0.02em',
        textTransform: 'none',
        borderRadius: '6px',
        fontSize: { xs: '0.65rem', sm: '0.7rem' },
        lineHeight: 1,
        minHeight: 30,
        ...(iconOnly
          ? { minWidth: 'auto', px: 0.75, '& .MuiSvgIcon-root': { fontSize: '1rem' } }
          : { px: 1.5 }
        ),
        py: 0.25,
        '&:hover': {
          backgroundColor: 'rgba(255, 255, 255, 0.12)',
          transform: 'translateY(-1px)'
        },
        '&:active': {
          transform: 'translateY(0)'
        },
        ...sx,
      }}
      {...rest}
    >
      {children}
    </Button>
  );
};

export default StyledButton;
